import type { CommendaAiConversationAccessView } from '@commenda/api/commenda-ai/types';
import { Icons, Tooltip } from '@commenda/kakashi';
import type { ReactNode } from 'react';
import { ChatIconButton } from './ChatIconButton';
import { ConversationVisibilityControl } from './ConversationVisibilityControl';
import { PanelCloseButton } from './PanelCloseButton';

/**
 * The buttons on the right of a panel chat's header, in one order for every panel.
 *
 * Sharing shows only once a conversation exists and is only changed from the full page. Expand is
 * offered by panels that have a full page to expand into; the workflow builder has none, because
 * leaving for `/agent` would abandon the workflow it is attached to. History is a slot rather than
 * a prop, since each surface scopes its own list.
 */
export const PanelHeaderActions = ({
  access,
  onStartNew,
  historyMenu,
  onExpand,
  onClose,
}: {
  access?: CommendaAiConversationAccessView;
  onStartNew: () => void;
  historyMenu?: ReactNode;
  onExpand?: () => void;
  onClose: () => void;
}) => (
  <>
    {access ? <ConversationVisibilityControl access={access} iconOnly /> : null}
    <Tooltip content="New chat" asChild>
      <ChatIconButton
        aria-label="New chat"
        onClick={onStartNew}
        icon={<Icons.Plus className="size-4" />}
      />
    </Tooltip>
    {onExpand ? (
      <Tooltip content="Open full screen" asChild>
        <ChatIconButton
          aria-label="Open full screen"
          onClick={onExpand}
          icon={<Icons.Expand01 className="size-4" />}
        />
      </Tooltip>
    ) : null}
    {historyMenu}
    <PanelCloseButton onClose={onClose} />
  </>
);
